import React from 'react';
import { Card, CardHeader, Col } from 'reactstrap';
import { H5, P } from '../../../AbstractElements';
import { saleViewChartOption } from '../../../Data/DashBoard/Default/Chart';
import Chart from 'react-apexcharts';
import { SellOverviewTitle, YearlySellingProductOverview } from '../../../Constant';
const SellOverview = () => {
  return (
    <Col xl='4' md='12' className='box-col-4 xl-30'>
      <Card className='sellview-sec'>
        <CardHeader className='card-header card-no-border pb-0'>
          <H5>{SellOverviewTitle}</H5>
          <div className='center-content'>
            <P>{YearlySellingProductOverview}</P>
          </div>
        </CardHeader>
        <div className='card-body'>
          <Chart options={saleViewChartOption.options} series={saleViewChartOption.series} type='bar' height={370} />
        </div>
      </Card>
    </Col>
  );
};

export default SellOverview;
